import React from 'react';
import { motion } from 'framer-motion';
export function AboutSection() {
  return <section id="about" className="py-24 bg-cream-100 relative" data-id="element-15">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-16">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-17">
          <h2 className="text-sm font-bold tracking-widest text-forest-700 uppercase mb-3" data-id="element-18">
            Who We Are
          </h2>
          <h3 className="text-3xl md:text-4xl font-heading font-bold text-earth-900" data-id="element-19">
            Not a big corporation. <br className="hidden sm:block" data-id="element-20" />
            Just real professionals who care.
          </h3>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-white rounded-2xl shadow-xl p-8 md:p-12 relative overflow-hidden" data-id="element-21">
          {/* Decorative element */}
          <div className="absolute top-0 right-0 w-32 h-32 bg-forest-500/10 rounded-bl-full -mr-4 -mt-4" data-id="element-22" />

          <p className="text-lg md:text-xl text-gray-700 leading-relaxed mb-10 relative z-10" data-id="element-23">
            <strong className="text-forest-900" data-id="element-24">Pancho's Lawn Care</strong> is a
            professional landscaping service with{' '}
            <strong data-id="element-25">12+ years of hands-on experience</strong>. We believe that
            quality, reliability, and your property's appearance are everything.
            We don't cut corners, and we don't rush the job.
          </p>

          <blockquote className="relative border-l-4 border-forest-500 pl-6 md:pl-8 py-2" data-id="element-26">
            <p className="text-2xl md:text-3xl font-heading font-medium text-earth-900 italic leading-snug mb-4" data-id="element-27">
              "My name is on every job I do. That's why every job is done
              right."
            </p>
            <footer className="text-forest-700 font-bold text-lg flex items-center gap-3" data-id="element-28">
              <div className="w-8 h-0.5 bg-forest-500" data-id="element-29" />
              Pancho
            </footer>
          </blockquote>
        </motion.div>
      </div>
    </section>;
}